var map = {
	"./authority.js": "da4e",
	"./authorizationmanagement.js": "bc89",
	"./barcode.js": "6c80",
	"./log.js": "6e02",
	"./manage.js": "9e7f",
	"./purchasesettings.js": "da73",
	"./purset.js": "7909",
	"./wechat.js": "d2b7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0d83";